import { Button, Checkbox, Popover, PopoverProps } from 'antd';
import React, { useState } from 'react';
import store from 'storejs';

interface IDimensionRemoveConfirmation extends PopoverProps {
  onConfirm?: () => void;
}

const NOT_REMIND_DIMENSION_REMOVAL_CONFIRMATION = 'not-remind-dimension-removal-confirmation';

const titleRender = () => {
  return (
    <div style={{ color: '#333', fontWeight: 500, letterSpacing: '-0.14px', width: 400 }}>
      <div>
        Dimension deletion will also apply to the dimensions in ‘Auto- breakdown’ section, continue?
      </div>
    </div>
  );
};

const DimensionRemoveConfirmation: React.FC<IDimensionRemoveConfirmation> = ({
  title,
  onConfirm,
  children,
  ...rest
}) => {
  const notRemind = store.get(NOT_REMIND_DIMENSION_REMOVAL_CONFIRMATION);

  const [open, setOpen] = useState<boolean>(false);

  const handleCancelPopover = () => {
    setOpen(false);
  };

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  const handleCheckNotShowAgain = (e) => {
    const checked = e.target.checked;
    if (checked) {
      store.set(NOT_REMIND_DIMENSION_REMOVAL_CONFIRMATION, 'true');
    } else {
      store.remove(NOT_REMIND_DIMENSION_REMOVAL_CONFIRMATION);
    }
  };

  if (notRemind) {
    const clonedChildren = React.isValidElement(children)
      ? React.cloneElement(children as React.ReactElement, {
          onClick: onConfirm,
        })
      : children;
    return <>{clonedChildren}</>;
  }

  return (
    <Popover
      title={title ? title : titleRender()}
      content={
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Checkbox
            style={{
              color: 'rgba(0, 0, 0, 0.45)',
              fontSize: '12px',
              fontWeight: 500,
            }}
            onChange={handleCheckNotShowAgain}
          >
            Don’t remind me again
          </Checkbox>
          <div style={{ display: 'flex', gap: '8px' }}>
            <Button style={{ borderRadius: '3px' }} onClick={handleCancelPopover}>
              Cancel
            </Button>
            <Button danger style={{ borderRadius: '3px' }} onClick={onConfirm}>
              Delete
            </Button>
          </div>
        </div>
      }
      placement="right"
      trigger="click"
      open={open}
      onOpenChange={handleOpenChange}
      getPopupContainer={(triggerNode) => triggerNode.parentElement ?? document.body}
      {...rest}
    >
      {children}
    </Popover>
  );
};

export default DimensionRemoveConfirmation;
